var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3992 34.9849C9.77235 34.9849 8.42438 36.1881 8.20164 37.7541H8.20072C7.92315 39.7214 9.44622 41.4464 11.3992 41.4464H35.8607V35.0772V34.9849C32.9698 34.9849 14.4264 34.9849 11.3992 34.9849Z",
    fill: "#33383F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3992 34.9849C9.77235 34.9849 8.42438 36.1881 8.20164 37.7541H8.20072C7.92315 39.7214 9.44622 41.4464 11.3992 41.4464H35.8607V35.0772V34.9849C32.9698 34.9849 14.4264 34.9849 11.3992 34.9849Z",
    fill: "#33383F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3998 41.4464V44.2156L26.6306 41.4464L23.8613 44.2156V41.4464V34.9849H29.3998V41.4464Z",
    fill: "#FD6814"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.707 11.1694V35.1694H23.8609H29.3993H35.8609V19.4771V15.7848V11.1694H13.707Z",
    fill: "#757D8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.707 6.55371H35.8609V11.1691H13.707V6.55371Z",
    fill: "#33383F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7084 11.1691V35.1691H11.4007C10.5081 35.1691 9.70131 35.5309 9.11608 36.1152C8.63423 36.5971 8.30377 37.2313 8.20315 37.9383H8.20223H8.16992V11.8152C8.16992 8.9094 10.5257 6.55371 13.4315 6.55371H13.7084V11.1691Z",
    fill: "#545B66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4315 6.55371C10.5257 6.55371 8.16992 8.9094 8.16992 11.8152V37.9383C8.17924 37.9383 8.21238 37.9383 8.20315 37.9383C8.42598 36.372 9.77423 35.1691 11.4007 35.1691H35.8622C35.8622 30.928 35.8622 10.4094 35.8622 6.55371C34.9762 6.55371 14.3984 6.55371 13.4315 6.55371Z",
    fill: "#757D8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4623 13.0156C43.8644 13.0156 45.0008 14.1519 45.0008 15.5541C45.0008 16.9562 43.8644 18.0925 42.4623 18.0925C41.0611 18.0925 39.9238 16.9562 39.9238 15.5541C39.9238 14.1519 41.0611 13.0156 42.4623 13.0156Z",
    fill: "#FAA71A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38462 29.6309C5.14985 29.6309 5.76923 30.2512 5.76923 31.0155C5.76923 31.7798 5.14985 32.4001 4.38462 32.4001C3.62031 32.4001 3 31.7798 3 31.0155C3 30.2512 3.62031 29.6309 4.38462 29.6309Z",
    fill: "#FAA71A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3848 17.6309H33.0002V25.9386H16.3848V17.6309Z",
    fill: "#07CC66"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.707 6.55371H35.8609V11.1691H13.707V6.55371Z",
    fill: "#33383F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7084 11.1691V35.1691H11.4007C10.5081 35.1691 9.70131 35.5309 9.11608 36.1152C8.63423 36.5971 8.30377 37.2313 8.20315 37.9383H8.20223H8.16992V11.8152C8.16992 8.9094 10.5257 6.55371 13.4315 6.55371H13.7084V11.1691Z",
    fill: "#545B66"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.538 7.47705C41.9211 7.47705 42.2303 7.7872 42.2303 8.16936C42.2303 8.55151 41.9211 8.86167 41.538 8.86167C41.1559 8.86167 40.8457 8.55151 40.8457 8.16936C40.8457 7.7872 41.1559 7.47705 41.538 7.47705Z",
    fill: "#4A78FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1532 38.3999C40.5363 38.3999 40.8456 38.7101 40.8456 39.0922C40.8456 39.4744 40.5363 39.7845 40.1532 39.7845C39.7711 39.7845 39.4609 39.4744 39.4609 39.0922C39.4609 38.7101 39.7711 38.3999 40.1532 38.3999Z",
    fill: "#4A78FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6923 23.1694C40.0754 23.1694 40.3846 23.4796 40.3846 23.8617C40.3846 24.244 40.0754 24.554 39.6923 24.554C39.3102 24.554 39 24.244 39 23.8617C39 23.4796 39.3102 23.1694 39.6923 23.1694Z",
    fill: "#4A78FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92278 3.78467C7.30585 3.78467 7.61508 4.09482 7.61508 4.47698C7.61508 4.85913 7.30585 5.16928 6.92278 5.16928C6.54062 5.16928 6.23047 4.85913 6.23047 4.47698C6.23047 4.09482 6.54062 3.78467 6.92278 3.78467Z",
    fill: "#4A78FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46184 42.0923C6.84492 42.0923 7.15415 42.4024 7.15415 42.7846C7.15415 43.1667 6.84492 43.4769 6.46184 43.4769C6.07969 43.4769 5.76953 43.1667 5.76953 42.7846C5.76953 42.4024 6.07969 42.0923 6.46184 42.0923Z",
    fill: "#4A78FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0009 19.9385C6.38398 19.9385 6.69321 20.2486 6.69321 20.6308C6.69321 21.0129 6.38398 21.3231 6.0009 21.3231C5.61875 21.3231 5.30859 21.0129 5.30859 20.6308C5.30859 20.2486 5.61875 19.9385 6.0009 19.9385Z",
    fill: "#4A78FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0008 28.154H16.3854C16.1305 28.154 15.9238 27.9474 15.9238 27.6925C15.9238 27.4375 16.1305 27.231 16.3854 27.231H33.0008C33.2557 27.231 33.4623 27.4375 33.4623 27.6925C33.4623 27.9474 33.2557 28.154 33.0008 28.154Z",
    fill: "#BDE1FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0008 30.0002H16.3854C16.1305 30.0002 15.9238 29.7936 15.9238 29.5387C15.9238 29.2837 16.1305 29.0771 16.3854 29.0771H33.0008C33.2557 29.0771 33.4623 29.2837 33.4623 29.5387C33.4623 29.7936 33.2557 30.0002 33.0008 30.0002Z",
    fill: "#BDE1FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0008 31.8464H16.3854C16.1305 31.8464 15.9238 31.6398 15.9238 31.3849C15.9238 31.1299 16.1305 30.9233 16.3854 30.9233H27.0008C27.2557 30.9233 27.4623 31.1299 27.4623 31.3849C27.4623 31.6398 27.2557 31.8464 27.0008 31.8464Z",
    fill: "#BDE1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.633727e630f1f0dba603008f84007e1c.svg";
export { ForwardRef as ReactComponent };